import { Link } from 'gatsby';
import React from 'react';

const Deparments = () => {
  return (
    <section className='faq-one'>
      <div className='container'>
        <div className='row no-gutters'>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>An</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/anaesthesia'>
                    Department Of Anaesthesia
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The history of the Department of Anaesthesia dates back to
                  1962 when the Lagos Medical School and Lagos University
                  Teaching Hospital were established. Clinical anaesthesia
                  commenced in August 1962 with the arrival of a group of four
                  Canadian doctors headed by the late Prof. Shirley Flemming.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>AMP</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/anatomic-path'>
                    Department Of Anatomic And Molecular Pathology{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Anatomic and Molecular Pathology, LUTH has
                  standard laboratories for Histochemistry, Immunohistochemistry
                  (IHC), Molecular Pathology and Cytogenetics. The department
                  renders quality diagnostic services in Cytopathology, Surgical
                  Pathology and Autopsy Pathology.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>AMP</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  Department of Accident and Emergency
                  {/* <Link to='/departments/anatomic-path'>
                    Department Of Anatomic And Molecular Pathology{' '}
                  </Link> */}
                </h2>
                <p className='faq-one__text'>
                  The Department of Anatomic and Molecular Pathology, LUTH has
                  standard laboratories for Histochemistry, Immunohistochemistry
                  (IHC), Molecular Pathology and Cytogenetics. The department
                  renders quality diagnostic services in Cytopathology, Surgical
                  Pathology and Autopsy Pathology.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>CD</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/child-dental'>
                    Department Of Child Dental Health{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Child Dental Health was created on August
                  1st, 1980 following the approval of the University Senate on
                  June 17th, 1980.
                </p>
              </div>
            </div>
          </div>

          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>CP</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/clinical-path'>
                    Department Of Clinical Pathology{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Clinical Pathology Department provides routine and
                  specialised Chemical Pathology Laboratory Services and
                  outpatient clinical services for metabolic disorders
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Ch</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/comm-health'>
                    Department Of Community Health & Primary Care{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Community Health of the Lagos University
                  Teaching Hospital (LUTH) has a mission of producing leaders in
                  public health for the country, provision of clinical services
                  and community-oriented research through the use of innovative
                  and technologically driven methods by highly competent and
                  motivated staff.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>ENT</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                    {' '}
                  <Link to='/departments/ent'>Department Of Ear, Nose And Throat</Link>
                </h2>
                <p className='faq-one__text'>
                  From the inception of the Hospital, Otorhinolaryngology
                  otherwise known as E.N.T was established as a unit in the
                  Department of Surgery. ENT specialists treat conditions such
                  as ear infection, hearing loss, dizziness, ringing in the ears
                  (called tinnitus), ear, face, or neck pain, and more. Nose
                  (rhinology)—Our noses facilitate breathing by helping to keep
                  out potentially harmful dirt, allergens, and other agents.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Fm</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/family-medicine'>
                    Department of Family Medicine
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  We offer first contact care through a team of seasoned Family
                  Physicians, Resident Doctors and Medical Officers who
                  effectively manage your health within Primary Care or refer to
                  a wealth of available specialized care, if need be.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>H</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/haematology'>
                    Department Of Haematology And Blood Transfusion{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Haematology and Blood Transfusion is one of
                  four Pathology Departments in the Lagos University Teaching
                  Hospital. The department offers both routine and specialized
                  haematology laboratory services including blood banking
                  services to the extensive clientele of the Lagos University
                  Teaching Hospital
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Mm</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/microbio'>
                    Department Of Medical Microbiology{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Medical Microbiology and Parasitology, Lagos
                  University Teaching Hospital is a foremost tertiary diagnostic
                  and research laboratory providing excellent services based on
                  international best practices.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>M</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/medicine'>Department of Medicine</Link>
                </h2>
                <p className='faq-one__text'>
                  One of the foundation Departments of the Lagos University
                  Teaching Hospital established at the inception in 1962, and is
                  currently one of the largest and most prominent Departments in
                  the LUTH.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>OP</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/nursing-services'>
                    Department Of Nursing Sevices{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The department of Nursing Services is a unique arm of the
                  Lagos University Teaching Hospital charged with the major
                  responsibility of nursing care to all our clients while
                  ensuring effective coordination of all activities towards the
                  delivery of quality care to patients.
                </p>
              </div>
            </div>
          </div>

          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Ob</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/obstetrics'>
                    Department of Obstetrics and Gynaecology
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  Obstetrics and Gynaecology is a unique specialty as it employs
                  Surgical and Internal Medicine methods. It is also the only
                  specialty that deals with two patients at the same time, name
                  the pregnant mother and her unborn baby. It is therefore, a
                  rich area for research activities and we are very passionate
                  about our students’ learning experiences, both undergraduate
                  and postgraduate.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Op</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/ophthalmology'>
                    Department Of Ophthalmology
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department, of Ophthalmology has been in existence since
                  1968 as a Unit within Department of Surgery of the Lagos
                  University Teaching Hospital (LUTH), Idi-Araba, Lagos, under
                  the Headship of Professor Istvan Rethy, a Hungarian
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>OP</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/oral-path'>
                    Department Of Oral And Maxillofacial Pathology{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The present department of Oral Biology and Oral Pathology
                  started as a unit of Oral Pathology in the department of Oral
                  Surgery/Oral Pathology in 1968 and had its 1st pioneer
                  professor in June 1969, that is, Prof. Roger Browne, a
                  visiting professor from University of Birmingham.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>OS</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/oral-surgery'>
                    Department Of Oral And Maxillofacial Surgery{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The school of Dental Sciences had a modest beginning as a
                  single Department of Dental Surgery headed by Professor J. W.
                  Fox-Taylor a British Oral Surgeon in 1966.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Or</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/orthopaedics'>
                    Department Of Orthopaedics And Traumatology{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Orthopaedic and Traumatology LUTH was
                  created out of the Department of Surgery, on 24th January,
                  2014. The Department offer services in all aspects of
                  Orthopaedics and Trauma.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Pa</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/paediatrics'>
                    Department Of Paediatrics
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Department of Paediatrics was established in 1963 to
                  provide holistic care for every child in health and sickness,
                  train medical and other healthcare professionals, conduct and
                  coordinate hospital and community-based research within and
                  without, in collaboration with allied specialties and
                  subspecialties
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>PD</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/preventive-dentistry'>
                    Department Of Preventive Dentistry{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  We are a multispecialty department with competent, goal and
                  research-oriented academic members of staff in the field of
                  Oral diagnosis & Oral Radiology, Oral Medicine, Periodontology
                  and Community Dentistry.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>Py</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/psychiatry'>
                    Department Of Psychiatry
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The primary roles of the Department include clinical services,
                  training of Medical Students, Resident Doctors as well as
                  other Health Professionals and Research.
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-6'
            style={{ paddingBottom: `0px`, borderBottom: `0px none` }}
          >
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>R</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  Department Of Radiation Oncology{' '}
                  {/* <Link to='/inprogress/departments/radiation'>
                  </Link> */}
                </h2>
                <p className='faq-one__text'>Inprogress</p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-6'
            style={{ paddingBottom: `0px`, borderBottom: `0px none` }}
          >
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>R</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/radiodiagnosis'>
                    Department Of Radiodiagnosis{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The Radiodiagnosis department provides Radiodiagnostic
                  services to patients which include; Paedistric Imaging, Women
                  Imaging, Imaging of the Adult Chest (Male and Female), Imaging
                  of the Central Nervous System, Imaging of the Muscular
                  Skeletal System, Peripheral Vascular Doppler Studies,
                  Nonvascular Interventional Radiology, with other services such
                  as; Training of Resident Doctors, and Research activities and
                  Grant Sourcing
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>RD</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/restorative-dentistry'>
                    Department Of Restorative Dentistry{' '}
                  </Link>
                </h2>
                <p className='faq-one__text'>
                  The department currently has seven honorary consultants to the
                  teaching hospital and works closely with the hospital
                  management to ensure quality restorative dental care to our
                  patients.
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>
              {/* <div className='faq-one__icon'>
                <span>S</span>
              </div> */}
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/departments/surgery'>Department Of Surgery</Link>
                </h2>
                <p className='faq-one__text'>
                  The department of surgery of the Lagos University Teaching
                  Hospital is one of the founding departments of the hospital,
                  which started when the hospital was created in 1961.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Deparments;
